<template>
  <div class="pay_popup">
    <div class="pay_popupcont">
      <img class="paylogo" src="../assets/img/paylogo.png" alt="">
      <div class="pay_popuptext">国际支付安全由CGM Pay担保。</div>
      <div class="pay_popupbox">
        <div class="pay_chosebox">
          <div class="pay_chosetxt">请选择以下中国主流的支付公司，与CGM Pay自动换汇。</div>
          <div class="pay_chosethree">
            <div class="paychoseitem"
                 v-for="(item, index) in paylist" :key="index"
                 :class="{ 'on': item.ischose }" @click="changeStyle(index)">
              <img class="default" :src="item.img" alt="">
              <img class="on" :src="item.img1" alt="">
              <div class="paychosetxt">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="pay_chosebox pay_detailbox">
          <div class="pay_detail">
            <div class="pay_detaillist">
              <div class="pay_detailleft">家庭配置药（{{ sum }}款）</div>
              <div class="pay_detairight">¥{{ price }}</div>
            </div>
            <div class="pay_detaillist">
              <div class="pay_detailleft">国际运费</div>
              <div class="pay_detairight">¥0</div>
            </div>
            <div class="pay_detaillist">
              <div class="pay_detailleft">支付手续费</div>
              <div class="pay_detairight">¥0</div>
            </div>
            <div class="pay_detaillist last">
              <div class="pay_detailleft">总计支付</div>
              <div class="pay_detairight">¥{{ price }}</div>
            </div>
          </div>
        </div>
        <div class="pay_chosebox">
          <div class="pay_detail">
            <div class="pay_address">配置家庭地址</div>
            <div class="pay_address">地址：{{ province }}{{ city }}{{ district }}{{ address }}</div>
            <div class="pay_address">电话：{{ receivingMobile }}</div>
            <div class="pay_address">收件人：{{ receiving }}</div>
            <div class="pay_address">身份证号：{{ cardId }}</div>
          </div>
        </div>
        <div class="pay_btn" @click="buy_click">支付</div>
      </div>
    </div>
  </div>
</template>
<script>
import {pcaTextArr} from "element-china-area-data";
import {Dialog} from "vant";
import {mapMutations, mapState} from "vuex";

export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem", "nowcart"]),
  },
  data() {
    return {
      userAddress: null,
      province: null,
      city: null,
      district: null,
      address: null,
      receiving: null,
      receivingMobile: null,
      vendor: "wechatpay",
      pcaTextArr,
      selectedOptions: [],
      nihaopay_qr_code: null,
      size: 300,
      centerDialogVisible: false,
      paypopupshow: false,
      loading: false,
      cgmPackage: {},
      cgmSpuList: [],
      spuVO: {},
      price: 0,
      total: 0,
      sum: 0,
      isYinlian: false,
      isZhifubao: false,
      isWechat: true,
      paylist: [
        {
          name: '微信',
          img: require('../assets/img/weixin1.png'),
          img1: require('../assets/img/weixin.png'),
          ischose: true,
        },
        {
          name: '支付宝',
          img: require('../assets/img/zhifubao.png'),
          img1: require('../assets/img/zhifubao1.png'),
          ischose: false,
        },
        {
          name: '银联',
          img: require('../assets/img/yinlian.png'),
          img1: require('../assets/img/yinlian1.png'),
          ischose: false,
        },
      ],
      userVO: {},
      cardId: '',
      cart: [],//当前购物车
      freight: 0,//运费
      isbag: null//药包
    };
  },
  mounted() {
    this.getAddress();
  },
  beforeRouteEnter(to, from, next) {
    next(that => {
      that.fromPath = from.path

      if (from.path === "/ConfigMedicine") {
        that.cart = JSON.parse(sessionStorage.getItem("nowcart"))
        that.price = that.$route.query.total
        // vm.total =parseFloat(vm.$route.query.total) + 80
        that.sum = that.$route.query.sum
        that.freight = 80
        that.isbag = false
      } else if (from.path === "/spu") {
        that.isbag = true
        that.cgmSpuRecords()
      }
    })
  },
  methods: {
    ...mapMutations(["setCgmUserVO", "setLeftItem"]),
    changeStyle(type) {
      for (var i in this.paylist) {
        this.paylist[i].ischose = false
      }
      if (type === 0) {
        this.vendor = 'wechatpay'
      } else if (type === 1) {
        this.vendor = 'alipay'
      } else if (type === 2) {
        this.vendor = 'unionpay'
      }
      this.paylist[type].ischose = true
    },
    cgmSpuRecords() {
      this.axios
          .get("/cgmSpu/getByPackageId", {
            params: {
              packageId: this.$route.query.packageId,
            },
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.cgmPackage = res.data.data;
              // this.total = res.data.data.rmbAmount;
              this.price = res.data.data.rmbAmount;
              this.cgmSpuList = res.data.data.cgmSpuList;
              this.sum = res.data.data.cgmSpuList.length;
            }
          });
    },
    getAddress() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
          .get("/cgmUser/getUserById", {
            params: {
              userId,
            },
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.userVO = res.data.data;
              this.province = res.data.data.cgmAddress.province
              this.city = res.data.data.cgmAddress.city
              this.district = res.data.data.cgmAddress.district
              this.address = res.data.data.cgmAddress.address
              this.receiving = res.data.data.cgmFamily.firstName + res.data.data.cgmFamily.lastName
              this.receivingMobile = res.data.data.mobile
              this.cardId = res.data.data.cgmFamily.cardId
            }
          });
    },
    buy_click() {
      if (this.cgmUserVO) {
        Dialog.confirm({
          title: '确认收货地址',
          message: '本产品系海外直邮，请再一次确认您的收货地址，确保收件正常',
          cancelButtonText: '修改地址',
          confirmButtonText: '继续支付'
        }).then(() => {
          if (this.isbag) {
            // 药包支付
            this.package_buy()
          } else {
            // 补充支付
            this.append_buy()
          }
        }).catch(() => {
          this.updateAddress()
        });
      } else {
        this.$router.push({path: "/login"});
        this.$message({type: "error", message: "请登录"});
      }
    },
    package_buy() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.loading = true;
      this.axios
          .post(
              "/securePay",
              {
                userId,
                packageId: this.$route.query.packageId,
                province: this.province,
                city: this.city,
                district: this.district,
                address: this.address,
                receiving: this.receiving,
                receivingMobile: this.receivingMobile,
                vendor: this.vendor,
              },
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
          )
          .then((res) => {
            if (res.data.code === 200) {
              let w = window.open("", "_self");
              w.document.write(res.data.data);
            }
            this.loading = false;
          });
    },

    append_buy() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.loading = true;
      this.axios
          .post("/spuAppendPay", {
            userId,
            packageId: this.$route.query.packageId,
            vendor: this.vendor,
            cgmSpuDTOList: this.cart,
          })
          .then((res) => {
            if (res.data.code === 200) {
              let w = window.open("", "_self");
              w.document.write(res.data.data);
            }
            this.loading = false;
          });
      // } else {
      //   const ua = navigator.userAgent.toLowerCase();
      //   if (/phone|mobile|android|iphone|ipad|ipod/i.test(ua)) {
      //     // this.$router.push({
      //     //   path: "/userAddress",
      //     // });
      //     this.$router.push({
      //       path: "/userSelf",
      //       query: {
      //         familyId: family_res.data.data.familyId,
      //       },
      //     });
      //     Toast.fail("请完善个人情报、收货地址");
      //   } else {
      //     this.setLeftItem(4);
      //     this.$router.push({
      //       path: "/userCenter",
      //     });
      //     this.$message({type: "error", message: "请先填写收货地址"});
      //   }
      // }
    },
  },
  async updateAddress() {
    let userId = JSON.parse(this.cgmUserVO).userId;
    this.axios
        .get("/cgmFamily/getMaster", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$router.push({
              path: "/userSelf",
              query: {
                familyId: res.data.data.familyId,
              },
            });
          }
        });
  }
};
</script>
<style lang="scss" scoped>
.pay_popup {
  padding: 33px 0 70px;
}

.pay_popupcont {
  width: 1160px;
  background: #F6F4F5;
  margin: 0 auto;
  padding: 60px 66px 80px 75px;
  box-sizing: border-box;
}

.paylogo {
  width: 200px;
  display: block;
  margin: 0 0 20px;
}

.pay_popuptext {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 20px;
}

.pay_chosebox {
  width: 100%;
  border-radius: 5px;
  margin-bottom: 24px;
  padding: 23px 0 28px 49px;
  box-sizing: border-box;
  background: #fff;
}

.pay_chosetxt {
  font-size: 20px;
  margin-bottom: 10px;
}

.pay_chosethree {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  text-align: center;
  gap: 23px;
}

.paychoseitem {
  width: 140px;
  height: 140px;
  border-radius: 10px;
  background: #fff;
  color: #1161BA;
  border: 1px solid #1161BA;
}

.paychoseitem.on {
  background: #1161BA;
  color: #fff;
}

.paychoseitem.on img.on {
  display: block;
}

img.on {
  display: none;
}

img.default {
  display: block;
}

.paychoseitem.on img.default {
  display: none;
}

.paychoseitem img {
  width: 50%;
  margin: 23px auto 0;
}

.paychosetxt {
  font-size: 20px;
}

.pay_detailbox.pay_chosebox {
  padding: 17px 22px;
}

.pay_detaillist {
  line-height: 46px;
  height: 46px;
  padding: 0 30px;
  overflow: auto;
}

.pay_detailleft {
  float: left;
}

.pay_detairight {
  float: right;
}

.pay_detaillist.last {
  border-top: 1px solid #F6D3E0;
}

.pay_detaillist.last .pay_detairight {
  font-size: 30px;
  color: #FF0000;
}

.pay_address {
  margin-bottom: 10px;
}

.pay_address:nth-last-child(1) {
  margin-bottom: 0;
}

.pay_btn {
  width: 100%;
  height: 69px;
  background-color: #1161BA;
  color: #fff;
  line-height: 69px;
  font-size: 30px;
  text-align: center;
  border-radius: 5px;
}

@media screen and (max-width: 1200px) {
  .pay_popupcont {
    width: 90%;
  }
}

@media screen and (max-width: 800px) {
  .pay_popupcont {
    padding: 40px 20px;
  }
  .pay_popuptext {
    font-size: 20px;
  }
  .pay_chosebox {
    padding: 20px 10px;
  }
  .pay_chosetxt {
    font-size: 14px;
  }
  .pay_detaillist {
    padding: 0 10px;
  }
  .pay_chosethree {
    gap: 10px;
  }
  .paychoseitem {
    height: 100px;
  }
  .paychosetxt {
    font-size: 14px;
  }
  .pay_btn {
    height: 50px;
    line-height: 50px;
    font-size: 18px;
  }
}
</style>
